<template>
  <svg width="48" height="28" viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.6257 9.93262H11.63C12.2546 11.6537 12.8928 13.4053 13.6031 15.3597C14.3542 13.5414 14.3392 11.6842 14.9869 9.94234H16.7559C16.1395 12.9191 15.5489 15.7764 14.9448 18.6935H12.9635C12.3009 16.8807 11.6464 15.093 10.8816 12.9983C10.4231 15.1166 10.0407 16.8877 9.64747 18.706H7.9248C8.27043 15.707 9.0855 12.8719 9.6257 9.93262Z"
      fill="#526C82"
      fill-opacity="0.8"
    />
    <path
      d="M40.5102 12.6249H39.0134C38.8433 12.3012 38.6787 11.9859 38.5304 11.7053C36.8621 11.0316 36.0811 11.3525 35.945 12.8166C36.2044 12.9574 36.4721 13.0817 36.7465 13.1888C37.2608 13.3597 37.7874 13.4916 38.3086 13.6403C40.4055 14.2362 40.9144 15.8489 39.5536 17.5866C38.4134 19.0451 35.6674 19.5633 34.0904 18.6173C33.1283 18.0408 32.8371 17.213 33.2195 16.0017H34.7163C34.8809 16.3365 35.0592 16.6962 35.2266 17.0324C35.8824 17.4672 36.5682 17.3671 37.2268 17.2505C37.7929 17.1491 38.2065 16.7976 38.2841 15.9628C38.012 15.8072 37.6976 15.5669 37.3452 15.4433C36.7941 15.2516 36.2076 15.1655 35.6484 14.9863C33.8726 14.4307 33.3651 12.9388 34.3938 11.34C35.4443 9.70782 38.1113 9.09941 39.7224 10.137C40.4735 10.6204 40.8341 11.3233 40.7252 12.2387C40.7062 12.3582 40.5987 12.4693 40.5102 12.6249Z"
      fill="#526C82"
      fill-opacity="0.8"
    />
    <path
      d="M15.7861 18.7251C17.4993 15.6511 19.0981 12.7854 20.6847 9.94897H22.8619C23.2701 12.866 23.6674 15.7094 24.0865 18.682H22.0495C21.923 18.1848 21.8005 17.7097 21.6563 17.1416H18.7824L17.8163 18.7251H15.7861ZM21.2984 12.8618L21.0358 12.7882L19.7717 15.2358H21.5501C21.459 14.3718 21.3841 13.6189 21.2984 12.8618Z"
      fill="#526C82"
      fill-opacity="0.8"
    />
    <path
      d="M26.8905 9.89794C28.3682 9.89794 29.7671 9.79376 31.1441 9.92572C32.6667 10.0646 33.2763 11.0925 32.9879 12.665C32.6327 14.5944 31.604 15.5431 29.6745 15.6737C29.0472 15.7154 28.4159 15.6737 27.6947 15.6737C27.5586 16.1876 27.4144 16.6585 27.2987 17.135C27.1831 17.6114 27.0851 18.1073 26.9613 18.688H25.0576C25.6019 15.7237 26.2033 12.8428 26.8905 9.89794ZM28.4499 11.6371C28.3043 12.4552 28.1777 13.1414 28.0594 13.8318C30.5086 14.1749 31.1251 13.7304 30.8624 11.8871C30.1549 11.3606 29.3616 11.5968 28.4499 11.6371Z"
      fill="#526C82"
      fill-opacity="0.8"
    />
    <rect
      x="3.07129"
      y="2.25"
      width="41.8571"
      height="23.5"
      rx="6.5"
      stroke="#526C82"
      stroke-opacity="0.8"
    />
  </svg>
</template>
